import { render, staticRenderFns } from "./PnetExtraVehicleInformation.vue?vue&type=template&id=f12e3ad2&scoped=true"
import script from "./PnetExtraVehicleInformation.vue?vue&type=script&lang=js"
export * from "./PnetExtraVehicleInformation.vue?vue&type=script&lang=js"
import style0 from "./PnetExtraVehicleInformation.vue?vue&type=style&index=0&id=f12e3ad2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12e3ad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f12e3ad2')) {
      api.createRecord('f12e3ad2', component.options)
    } else {
      api.reload('f12e3ad2', component.options)
    }
    module.hot.accept("./PnetExtraVehicleInformation.vue?vue&type=template&id=f12e3ad2&scoped=true", function () {
      api.rerender('f12e3ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/PnetExtraVehicleInformation.vue"
export default component.exports